import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import logoImage from "../assets/Star.Ryhwa.PNG";
import { SITE_SETTINGS } from "../config/siteSettings";
import "../styles/UnderConstruction.css";

export const UnderConstruction = ({ onClose }) => {
  const { popup } = SITE_SETTINGS;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div className="uc-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="uc-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="uc-close"
          onClick={onClose}
          aria-label="Close"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="uc-logo-wrap">
          <img src={logoImage} alt="Star.Ryhwa" className="uc-logo" />
        </div>

        <h2 className="uc-title">{popup.title}</h2>

        <p className="uc-text">{popup.message}</p>

        <a
          href={popup.instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="uc-insta-link"
        >
          <FontAwesomeIcon icon={faInstagram} className="uc-insta-icon" />
          <span>Follow {popup.instagramHandle} on Instagram</span>
        </a>

        <button
          type="button"
          className="uc-preview-btn"
          onClick={onClose}
        >
          {popup.buttonText}
        </button>
      </div>
    </div>
  );
};

export default UnderConstruction;
